import { IconButton } from "@smartsuite/react-ui/lib/components/buttons/IconButton";
import { type Placements, Tooltip } from "@smartsuite/react-ui/lib/components/help/Tooltip";
import { isDocEmpty } from "@smartsuite/smartdoc";
import { type EditorData, GrayColors } from "@smartsuite/types";
import cx from "clsx";
import { SmartDocRenderer } from "../SmartDocRenderer/SmartDocRenderer";

import "./HelpTextTooltip.sass";
import { Text } from "@smartsuite/react-ui/lib";

const tooltipPlacements: Placements = ["top", "bottom", "left", "right"];

interface HelpTextTooltipProps {
  fieldName: string;
  helpText?: EditorData;
  labelContainerRef: React.RefObject<HTMLDivElement>;
}

export const HelpTextTooltip = ({
  fieldName,
  helpText,
  labelContainerRef,
}: HelpTextTooltipProps): JSX.Element | null => {
  if (!helpText || isDocEmpty(helpText.data as Parameters<typeof isDocEmpty>[0])) {
    return null;
  }

  return (
    <div className={cx("form-field-control__tooltip")}>
      <Tooltip
        className="'edit-record-field-help-text-tooltip'"
        display="inline-flex"
        closingMode="click-outside"
        openingMode="click"
        showClose={true}
        padding={2}
        closeIconColor={GrayColors["G-5"]}
        closeIconHoverColor={GrayColors["G-8"]}
        arrowColor={GrayColors["G-0"]}
        itemClasses="edit-record-field-help-text-tooltip__tooltip"
        placements={tooltipPlacements}
        maxWidth={400}
        contentBackground={GrayColors["G-0"]}
        target={
          <IconButton
            name="info-thin"
            color={GrayColors["G-6"]}
            hoverColor={GrayColors["G-8"]}
            size="S"
            ariaLabel="info-baloon"
          />
        }
        renderTooltipContent={
          <>
            <Text
              size="s"
              weight="medium"
              className="edit-record-field-help-text-tooltip__field-name"
            >
              {fieldName}
            </Text>
            <SmartDocRenderer editorData={helpText} />
          </>
        }
        triggerOpenElement={labelContainerRef as unknown as React.RefObject<HTMLButtonElement>}
      />
    </div>
  );
};
